import * as LocalStorageService from '@/services/LocalStorageService'
import * as Server from '@/services/Server'

/**
 * Bootstrap request, shared between all callers and reused for the whole session: the startup
 * data is asked to the server only once.
 */
let bootstrapRequest = null

export const storeActions = {
  // just a test
  increment()
  {
    this.count++
    LocalStorageService.saveState()
  },

  setProperty(key, value, parentKey)
  {
    if (parentKey){
      this[parentKey][key] = value
    } else {
      this[key] = value
    }
    LocalStorageService.saveState()
  },

  unsetProperty(key, parentKey)
  {
    if (parentKey){
      this[parentKey][key] = null
    } else {
      this[key] = null
    }
    LocalStorageService.saveState()
  },

  startLoading(key)
  {
    this.system.loading[key] = true
  },
  finishedLoading(key)
  {
    this.system.loading[key] = false
  },

  /**
   * Load the client bootstrap data (tracks for now) into the store.
   * Call it once, when entering the site: from then on the client never asks the server for this
   * information again. Later calls reuse the same request.
   */
  loadBootstrap()
  {
    if (!bootstrapRequest){
      bootstrapRequest = Server.get(this.apiPath.bootstrap)
        .then(response => {
          this.serverConfig = response.data?.data ?? {}
        })
        .catch(() => {
          // No data: tracks stay empty, but a retry is possible later.
          this.serverConfig = {}
          bootstrapRequest = null
        })
    }

    return bootstrapRequest
  }

}